import React from "react";
import { Link } from "react-router-dom";
import { Activity } from "lucide-react";
import { useI18n } from "../lib/i18n";

export function Brand({ to = "/", className = "" }) {
  return (
    <Link to={to} className={`flex items-center gap-2 ${className}`} data-testid="brand-link">
      <div className="w-9 h-9 rounded-xl bg-blue-700 text-white grid place-items-center shadow-sm">
        <Activity className="w-5 h-5" strokeWidth={2.5} />
      </div>
      <div className="font-heading font-bold text-xl tracking-tight text-slate-900">
        FilePro
      </div>
    </Link>
  );
}

export function LanguageToggle({ className = "" }) {
  const { lang, setLang } = useI18n();
  return (
    <div className={`inline-flex items-center rounded-full border border-slate-200 bg-white p-1 text-sm ${className}`}>
      <button
        type="button"
        data-testid="lang-fr"
        onClick={() => setLang("fr")}
        className={`px-3 py-1 rounded-full transition ${lang === "fr" ? "bg-blue-700 text-white" : "text-slate-600 hover:text-slate-900"}`}
      >
        FR
      </button>
      <button
        type="button"
        data-testid="lang-en"
        onClick={() => setLang("en")}
        className={`px-3 py-1 rounded-full transition ${lang === "en" ? "bg-blue-700 text-white" : "text-slate-600 hover:text-slate-900"}`}
      >
        EN
      </button>
    </div>
  );
}
